"use client";

import { Button, Typography } from "@kyan/ui";

import { useBugBountyController } from "./BugBounty.controller";

export const BugBounty = () => {
  const { handleClick } = useBugBountyController();

  return (
    <div className="grid gap-2 sm:gap-4">
      <Typography element="h3">Bug Bounty</Typography>
      <Typography>
        Notice some issues on the UI and app functionality? Report it and
        receive rewards.
      </Typography>
      <Button variant="secondary" className="max-w-40" onClick={handleClick}>
        Report
      </Button>
    </div>
  );
};
